import Checkbox from '@a3/chameleon/src/components/basic/Checkbox';
import Typograf from '@a3/chameleon/src/components/basic/Typograf';
import type { ReactElement } from 'react';
import React from 'react';

import type { SelectOptionType } from 'components/complex/forms/ApplicationForm/types';

import ALink from '../../../basic/ALink';

import s from './ApplicationForm.module.scss';

export const values: SelectOptionType[] = [
  { value: '1', label: 'Телефон' },
  { value: '2', label: 'WhatsApp' },
  { value: '3', label: 'Telegram' },
  { value: '4', label: 'Email' },
];
export const recaptchaApiKey = '6LesiMIgAAAAACOqcL-eRNY3xLpGztchfESHHt9k';

export const agreementText = (
  setIsAgreementChecked: (checked: boolean) => void,
  setIsRepresentativeAgreementChecked: (checked: boolean) => void,
  setIsNewsletterAgreementChecked: (checked: boolean) => void,
): ReactElement => {
  return (
    <Typograf>
      <Checkbox
        className={s.checkboxWrapper}
        name="pdn"
        id="pdn"
        labelText={
          <div>
            Подтверждаю, что ознакомлен с{' '}
            <ALink
              className={s.link}
              href="https://www.a-3.ru/files/politika-pdn-20-06-2025.pdf"
              target="_blank"
            >
              Политикой обработки персональных данных ООО "Платежный сервис А3"
            </ALink>
          </div>
        }
        onChange={(checked): void => {
          setIsAgreementChecked(checked);
        }}
      />
      <Checkbox
        className={s.checkboxWrapper}
        name="representativePdn"
        id="representativePdn"
        labelText={
          <div>
            Подтверждаю, что даю{' '}
            <ALink
              className={s.link}
              href="https://www.a-3.ru/files/soglasie-na-obrabotku-pdn-20-06-2025.pdf"
              target="_blank"
            >
              согласие на обработку персональных данных
            </ALink>
          </div>
        }
        onChange={(checked): void => {
          setIsRepresentativeAgreementChecked(checked);
        }}
      />
      <Checkbox
        className={s.checkboxWrapper}
        name="newsletter"
        id="newsletter"
        labelText={
          <div>
            Подтверждаю, что даю{' '}
            <ALink
              className={s.link}
              href="https://www.a-3.ru/files/soglasie-na-rassylku-20-06-2025.pdf"
              target="_blank"
            >
              согласие на получение рассылки
            </ALink>{' '}
            рекламно-информационных материалов
          </div>
        }
        onChange={(checked): void => {
          setIsNewsletterAgreementChecked(checked);
        }}
      />
    </Typograf>
  );
};
